export const SECTORS_PER_ROW = 3;
